import React from 'react'
import styled, { css } from 'styled-components'
import { func, number, string, object, bool } from 'prop-types'
import { stripUnit, rgba } from 'polished'

import { fontWeights, fontSizes } from 'styles/typography'
import { greyDark, white, black } from 'styles/colors'
import { animationTime, animationCurve, square } from 'styles/global'
import * as spacing from 'styles/spacing'

import Icon from 'components/Icon'

import MinusSmall from 'icons/minus-small.svg'
import PlusSmall from 'icons/plus-small.svg'

const Container = styled.div`
  display: inline-flex;
  align-items: center;
`

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${black};
  flex-shrink: 0;
  border-radius: 50%;
  background-color: transparent;
  transition: all ${animationTime} ${animationCurve};
  border: 2px solid ${black};
  ${square('36px')};

  ${props =>
    props.isSmall &&
    css`
      ${square('26px')};
    `}

  ${props =>
    props.shadow &&
    css`
      border: 0;
      box-shadow: 0px 4px 32px ${rgba(black, 0.2)};
    `}

  ${props =>
    props.contrast &&
    css`
      color: ${white};
      border-color: ${white};

      ${props =>
        props.isSmall &&
        css`
          border-width: 1px;
        `}
    `}

  &[disabled] {
    opacity: 0.3;
  }
`

const Value = styled.span`
  color: ${greyDark};
  font-weight: ${fontWeights.bold};
  min-width: 36px;
  margin: 0;
  user-select: none;
  padding: 0 ${stripUnit(spacing.small) * 1.5 + 'px'};
  text-align: center;

  ${props =>
    props.isSmall &&
    css`
      font-size: ${fontSizes.small};
      min-width: 28px;
      padding: 0 ${spacing.small};
    `}

  ${props =>
    props.contrast &&
    css`
      color: ${white};
    `}
`

const QuantityPicker = ({
  onChange,
  value,
  title,
  product,
  contrast,
  disableAdd,
  disabledMinus,
  isAvailableForSale,
  isSmall,
  shadow
}) => {
  const availableForSale = typeof isAvailableForSale === 'undefined' || isAvailableForSale

  return (
    <Container>
      <Button
        type="button"
        isSmall={isSmall}
        contrast={contrast}
        shadow={shadow}
        onClick={() => {
          onChange(-1, title, product?.id)
        }}
        disabled={value === 0 || disabledMinus || !availableForSale}
      >
        <Icon icon={<MinusSmall />} size={isSmall ? 'small' : null} />
      </Button>
      <Value isSmall={isSmall} contrast={contrast}>
        {value}
      </Value>
      <Button
        type="button"
        isSmall={isSmall}
        contrast={contrast}
        shadow={shadow}
        onClick={() => {
          onChange(+1, title, product?.id)
        }}
        disabled={disableAdd || !availableForSale}
      >
        <Icon icon={<PlusSmall />} size={isSmall ? 'small' : null} />
      </Button>
    </Container>
  )
}

QuantityPicker.propTypes = {
  onChange: func.isRequired,
  value: number.isRequired,
  title: string,
  product: object,
  contrast: bool,
  disableAdd: bool,
  disabledMinus: bool,
  shadow: bool,
  isSmall: bool,
  isAvailableForSale: bool
}

export default QuantityPicker
